import React from "react";
import { useLocation } from "react-router-dom";
import Footer from "../footer/Footer.jsx";   // make sure this matches your file
// import ChatWidget from "../ChatWidget/ChatWidget"; // comment out if not used

const Layout = ({ children }) => {
  const location = useLocation();

  // Routes where footer and chat should be hidden
  const hideFooterAndChat = ["/best-rates"];

  return (
    <>
      <main>{children}</main>
      {!hideFooterAndChat.includes(location.pathname) && <Footer />}
      {/* {!hideFooterAndChat.includes(location.pathname) && <ChatWidget />} */}
    </>
  );
};

export default Layout;
